<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Nouveau Colis</h5>
      <button type="button" class="btn btn-primary" @click="importModel">
        <i class="flaticon-cloud-computing me-2"></i>
        <span>Télecharger Un modèle</span>
      </button>
    </div>
    <div class="card-body">
      <hr />
      <div class="mb-3">
        <input
          type="file"
          class="form-control"
          placeholder="Choisissez un fichier ou déposez-le ici..."
          accept=".xlsx,.xls"
          :key="fileInputKey"
          @change="onFileChange"
          :disabled="load"
        />
        <div v-if="import_file" class="mt-2">
          Le fichier Importé: <strong>{{ import_file.name }}</strong>
        </div>
      </div>
      <div class="mt-4">
        <button
          type="button"
          class="btn btn-success"
          @click="ImportColis"
          :disabled="load"
        >
          <span
            v-if="load"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          <i class="flaticon-cloud-computing me-2"></i>
          Enregistrer les colis
        </button>
        <button
          type="button"
          class="btn btn-danger ms-3"
          v-if="import_file"
          @click="RemoveFile"
          :disabled="load"
        >
          <i class="flaticon-delete me-2"></i>
          Supprimer le fichier importé
        </button>
      </div>
      <hr />
    </div>
  </div>

  <div v-if="ListColis.length != 0" class="card mt-4 mb-20">
    <div class="card-header">
      <h5 class="mb-0">Nouveau Colis</h5>
    </div>
    <div class="card-body">
      <form>
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th>Code suivi</th>
                <th>Destinataire</th>
                <th>Téléphone</th>
                <th>Adresse</th>
                <th>Prix</th>
                <th>Ville</th>
                <th>Commentaire</th>
                <th>Produit</th>
                <!-- <th class="text-center">
                  <small class="d-block text-muted mb-1">Fragile</small>
                  <select
                    class="form-select form-select-sm shadow-none"
                    v-model="fragile"
                    @change="AllFragile()"
                  >
                    <option :value="1">Oui</option>
                    <option :value="0">Non</option>
                  </select>
                </th> -->
                <th>Type Colis</th>
                <th class="text-center">
                  <small class="d-block text-muted mb-1">Ouvrir</small>
                  <select
                    class="form-select form-select-sm shadow-none"
                    v-model="open"
                    @change="AllOpen()"
                  >
                    <option :value="1">Oui</option>
                    <option :value="0">Non</option>
                  </select>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(coli, index) in ListColis" :key="index">
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="coli.code_suivi"
                    :style="
                      coli.error == 'code exist' ? 'border-color: red;' : ''
                    "
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="coli.destinataire"
                    :style="
                      coli.error == 'error dest' || !coli.destinataire
                        ? 'border-color: red;'
                        : ''
                    "
                    required
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="coli.telephone"
                    :style="
                      coli.phone_error || !coli.telephone
                        ? 'border-color: red;'
                        : ''
                    "
                    @change="
                      BlackList(coli);
                      checkWhite(coli);
                    "
                    @input="checkPhone(coli)"
                    required
                    minlength="10"
                    maxlength="10"
                  />
                  <div v-if="coli.phone_error" class="text-danger small">
                    Erreur numéro téléphone
                  </div>
                  <div v-if="coli.bl" class="text-warning small">
                    * {{ coli.bl }}
                  </div>
                  <div v-if="coli.wl" class="text-warning small">
                    * {{ coli.wl }}
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="coli.adresse"
                    :style="
                      coli.error == 'error adresse' || !coli.adresse
                        ? 'border-color: red;'
                        : ''
                    "
                    required
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="coli.prix"
                    min="0"
                    :style="coli.error_price ? 'border-color: red;' : ''"
                    @change="GetPrice(coli, index)"
                    required
                  />
                </td>
                <td>
                  <v-select
                    class="custom-select-height"
                    :id="'city' + index"
                    :style="[
                      coli.error_city ? { border: '1px solid red' } : '',
                    ]"
                    v-model="coli.city"
                    :options="CitiesList"
                    label="ville"
                    @input="GetId(coli, index)"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="coli.commentaire"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="coli.produit"
                  />
                </td>
                <!-- <td class="text-center">
                  <div class="form-check form-switch d-inline-block">
                    <input
                      class="form-check-input hover-pointer"
                      type="checkbox"
                      v-model="coli.fragile"
                      :true-value="1"
                      :false-value="0"
                    />
                  </div>
                </td> -->
                <td>
                  <select
                    class="form-control form-select"
                    v-model="coli.replace"
                  >
                    <option :value="0">Simple</option>
                    <option :value="1">Change</option>
                    <!-- <option :value="2">Partial</option> -->
                  </select>
                  <div v-if="coli.replace == 2" class="d-flex gap-2 mt-1">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="Nombre envoyé"
                      v-model="coli.nbr_sent"
                    />
                    <input
                      type="number"
                      class="form-control"
                      placeholder="Nombre à retourné"
                      v-model="coli.nbr_rtrn"
                    />
                  </div>
                </td>
                <td class="text-center">
                  <div class="form-check form-switch d-inline-block">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="coli.open"
                      :true-value="1"
                      :false-value="0"
                    />
                  </div>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    title="Supprimer"
                    @click="RemoveRow(coli)"
                  >
                    <i class="flaticon-delete"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <button
              type="button"
              class="btn btn-primary"
              @click="SaveColis"
              :disabled="load_add"
            >
              <span
                v-if="load_add"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Enregistrer les colis
            </button>
          </div>
          <div class="col-12 mt-2">
            <div class="progress" style="height: 20px">
              <div
                class="progress-bar"
                role="progressbar"
                :style="{ width: progress + '%' }"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ progress }}%
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>


<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { onMounted } from "vue";
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();

    const import_file = ref<File | null>(null);
    const ListColis = ref([]);
    const CitiesList = ref([]);
    const fragile = ref(0);
    const open = ref(1);
    const replace = ref(0);
    const ReplaceList = [
      { value: 1, text: "Oui" },
      { value: 0, text: "Non" },
    ];
    const pourcentage = ref(0);
    const load = ref(false);
    const load_add = ref(false);
    const progress = ref(0);
    const fileInputKey = ref(0);
    const StoresList = ref([]);

    async function ImportColis() {
      // console.log(import_file.value);
      // console.log(importedFile.value);

      if (!import_file.value) return;

      let formData = new FormData();
      formData.append("import_file", import_file.value); // must be a File object

      load.value = true;
      try {
        const response = await api.post(
          `/api/auth/client/ImportColis`,
          formData,
          {
            // ❌ remove this line
            headers: { "content-type": "multipart/form-data" },
          }
        );

        if (response.data.msg === "success") {
          ListColis.value = response.data.data;
          // your mapping logic...
        } else if (
          response.data.msg === "empty file" ||
          response.status === 422
        ) {
          showToast("Merci de verifier votre fichier Excel", "error");
        }
      } catch (error) {
        import_file.value = null;
        fileInputKey.value += 1;
        showToast("Merci de verifier votre fichier Excel", "error");
        console.error("Error importing colis:", error);
      } finally {
        load.value = false;
      }
    }
    const importedFile = ref(null);

    function onFileChange(e) {
      if (e.target.files && e.target.files.length > 0) {
        import_file.value = e.target.files[0]; // ✅ correct
        importedFile.value = e.target.files[0];
        console.log("File selected:", import_file.value);
      }
    }

    function RemoveFile() {
      import_file.value = null;
      fileInputKey.value += 1; // Reset file input
      console.log("File removed");
      ListColis.value = [];
    }
    async function importModel() {
      try {
        const response = await api.get(`/api/auth/client/ModelImport`, {
          responseType: "arraybuffer",
        });
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "ModeleColis.xlsx");
        document.body.appendChild(fileLink);
        fileLink.click();
      } catch (error) {
        console.error("Error downloading import model:", error);
      }
    }

    async function BlackList(row: any) {
      row.bl = "";
      //   const perms = JSON.parse(localStorage.getItem("PermsCstmr") || "null");
      //   if (perms && perms.black_list === 1) {
      if (row.telephone && row.telephone.length === 10) {
        try {
          const response = await api.post(
            `/api/auth/client/blackList?phone=${row.telephone}`
          );
          if (response.data.msg !== "no perms") {
            if (response.data.msg === "exist") {
              row.bl = "Numéro est dans Black Liste ";
            } else if (response.data.msg === "not exist") {
              row.bl = "Numéro n'est pas dans la white Liste ";
            } else {
              row.bl = "";
            }
          }
        } catch (error) {
          console.error("Error checking blacklist:", error);
        }
      }
      //   }
    }

    async function checkWhite(row: any) {
      row.wl = "";
      if (row.telephone && row.telephone.length === 10) {
        try {
          const response = await api.post(
            `/api/auth/client/whiteList?phone=${row.telephone}`
          );
          if (response.data.msg !== "no perms") {
            if (response.data.msg === "exist") {
              row.wl = "Numéro est dans la white Liste";
            } else {
              row.wl = "";
            }
          }
        } catch (error) {
          console.error("Error checking whitelist:", error);
        }
      }
    }

    function SubstrPhone(val: string) {
      if (val && val !== "" && val !== null) {
        let phone = "";
        if (val.substring(0, 1) === "0" && val.length === 10) {
          phone = val;
          return phone;
        } else if (
          (val.substring(0, 1) === "6" || val.substring(0, 1) === "7") &&
          val.length === 9
        ) {
          phone = "0" + val;
          return phone;
        }
      } else {
        return val;
      }
    }

    function checkPhone(coli: any) {
      if (
        /^(\+212|0)([ \-_/]*)(\d[ \-_/]*){9}$/.test(coli.telephone) === false
      ) {
        coli.phone_error = true;
      } else {
        coli.phone_error = false;
      }
    }

    function GetId(coli: any, index: number) {
      ListColis.value[index].error_city = false;
    }

    function GetPrice(coli: any, index: number) {
      if (
        !isNaN(ListColis.value[index].prix) &&
        Number(ListColis.value[index].prix) >= 0
      ) {
        ListColis.value[index].error_price = false;
      } else {
        ListColis.value[index].error_price = true;
      }
    }

    function isPositiveFloat(s: any) {
      return !isNaN(s) && Number(s) >= 0;
    }

    async function SaveColis() {
      progress.value = 0;

      if (ListColis.value.some((el: any) => el.exist === false)) {
        showToast("Merci de vérifier les villes des colis", "error");
        return;
      }

      let isValid = true; // Replace with actual validation if needed
      if (!isValid) {
        showToast("Merci de vérifier les informations des colis", "error");
        return;
      }

      let data = new FormData();
      data.append("colis", JSON.stringify(ListColis.value));

      load_add.value = true;

      // Start simulating progress
      const interval = setInterval(() => {
        if (progress.value < 95) {
          // Stop at 95% until API finishes
          progress.value += 5;
        }
      }, 300); // Adjust speed as needed

      try {
        const response = await api.post(
          `/api/auth/client/GetImportColis`,
          data
        );

        // API finished → set progress to 100%
        progress.value = 100;

        if (response.data.message === "success") {
          showToast("Colis ajoutés avec succès", "success");
          ListColis.value = response.data.rows || [];
        }
      } catch (error) {
        console.error("Error saving colis:", error);
        showToast("Erreur lors de l'ajout des colis", "error");
      } finally {
        clearInterval(interval); // Stop the simulated progress
        load_add.value = false;
      }
    }

    function RemoveRow(row: any) {
      const index = ListColis.value.indexOf(row);
      if (index > -1) {
        ListColis.value.splice(index, 1);
      }
    }

    function AllFragile() {
      for (let j = 0; j < ListColis.value.length; ++j) {
        ListColis.value[j].fragile = fragile.value;
      }
    }

    function AllOpen() {
      for (let j = 0; j < ListColis.value.length; ++j) {
        ListColis.value[j].open = open.value;
      }
    }

    async function getReplace(coli: any, code: string) {
      coli.existcolis = false;
      let data = new FormData();
      data.append("codesuivi", code);
      try {
        const res = await api.post(`/api/auth/client/ColisExist`, data);
        if (res.data === "not exist") {
          coli.existcolis = true;
        } else if (res.data === "exist") {
          coli.existcolis = false;
        }
      } catch (error) {
        console.error("Error checking colis existence:", error);
      }
    }

    onMounted(async () => {
      try {
        // Fetch Cities List
        const response = await api.get(`/api/auth/client/SelectCitiesList`);

        CitiesList.value = response.data || [];
        console.log("Cities fetched:", CitiesList.value);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    });

    return {
      import_file,
      ListColis,
      CitiesList,
      fragile,
      open,
      replace,
      ReplaceList,
      pourcentage,
      load,
      load_add,
      progress,
      fileInputKey,
      StoresList,
      ImportColis,
      onFileChange,
      RemoveFile,
      importModel,
      BlackList,
      checkWhite,
      SubstrPhone,
      checkPhone,
      GetId,
      GetPrice,
      isPositiveFloat,
      SaveColis,
      RemoveRow,
      AllFragile,
      AllOpen,
      getReplace,
    };
  },
});
</script>

<style scoped>
/* Remove heavy borders from inputs inside the table */
.table .form-control, .table .form-select {
    border: 1px solid #e9ecef;
    font-size: 0.85rem;
    padding: 0.35rem 0.5rem;
}

.table .form-control:focus, .table .form-select:focus {
    border-color: #3f51b5;
    box-shadow: none;
}

/* Make table headers look lighter */
.table-header th {
    background-color: #f8f9fa;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    font-weight: 600;
    vertical-align: middle;
}

/* Hover pointer for switches */
.hover-pointer {
    cursor: pointer;
}

/* Better spacing for the responsive table */
.table-responsive {
    overflow-x: auto;
    scrollbar-width: thin;
}
</style>

